import get from "lodash/get";
import {FaLocationDot, FaWifi} from "react-icons/fa6";
import {LuCalendarClock} from "react-icons/lu";
import {MdOutlineDevices} from "react-icons/md";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {shortDateTimeUser} from "@/lib/format.tsx";
import {MonitoringServiceChoices} from "@/lib/types/checks.ts";
import {MonitoringServer} from "@/lib/types/monitoring.ts";
import {PagespeedLHR, PSReportOptions} from "@/pages/pagespeed/types.ts";

interface PSChecksParamBlockProps {
  lhr: PagespeedLHR;
  monitoringServer?: MonitoringServer;
  mspChoices: MonitoringServiceChoices;
  options?: PSReportOptions;
}
export const PSChecksParamBlock = ({lhr, monitoringServer, options, mspChoices}: PSChecksParamBlockProps) => {
  const {user} = useCurrentUserContext();
  const emulatedDevice = options
    ? get(mspChoices.emulated_device, options?.settings.pagespeed_emulated_device, "Chrome")
    : "Chrome";
  const throttling = options?.settings.pagespeed_connection_throttling;
  return (
    <div className="d-flex flex-wrap mb-5 gap-10">
      <div className="flex-fill metric d-flex align-items-top">
        <LuCalendarClock className="text-success me-2" />
        <div>
          <span className="label">Report Generated</span>
          <span className="value value-sm">{shortDateTimeUser(lhr.fetchTime, user!)}</span>
        </div>
      </div>
      <div className="flex-fill d-flex align-items-top metric">
        <FaLocationDot className="text-success me-2" />
        <div>
          <span className="label">Test Server Location</span>
          <span className="value value-sm">{monitoringServer?.location ? monitoringServer.location : "N/A"}</span>
        </div>
      </div>
      <div className="flex-fill metric d-flex align-items-top">
        <MdOutlineDevices className="me-2 text-success" />
        <div>
          <span className="label">Using</span>
          <span className="value value-sm">{emulatedDevice}</span>
        </div>
      </div>
      {options && options.settings.pagespeed_connection_throttling != "UNTHROTTLED" && (
        <div className="flex-fill metric d-flex align-items-center">
          <FaWifi className="me-2 text-success" />
          <div>
            <span className="label">Connection</span>
            <span className="value value-sm">{throttling && get(mspChoices.connection_throttling, throttling)}</span>
          </div>
        </div>
      )}
    </div>
  );
};
